/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Sync_Model_SizeInputs */



/**
* | output |
* | --- |
* | "Model Size" |
*
* @param {Offline_Sync_Model_SizeInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_sync_model_size = /** @type {((inputs?: Offline_Sync_Model_SizeInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Sync_Model_SizeInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Taille du modèle")
	if (locale === "de") return /** @type {LocalizedString} */ ("Modellgröße")
	if (locale === "it") return /** @type {LocalizedString} */ ("Dimensione modello")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Размер модели")
	if (locale === "es") return /** @type {LocalizedString} */ ("Tamaño del modelo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("模型大小")
	if (locale === "ja") return /** @type {LocalizedString} */ ("モデルサイズ")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मॉडल आकार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Tamanho do modelo")
	return /** @type {LocalizedString} */ ("Model Size")
});